import React, { useState } from 'react';

import Button from '@atlaskit/button/new';
import { cssMap } from '@atlaskit/css';
import FlaskIcon from '@atlaskit/icon/core/flask';
import Modal, { ModalBody, ModalHeader, ModalTitle, ModalTransition } from '@atlaskit/modal-dialog';
import { Box, Inline } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import { StatsigLocalOverridesTab } from './statsig-local-overrides';

const styles = cssMap({
	buttonWrapper: {
		position: 'fixed',
		bottom: token('space.200'),
		left: token('space.200'),
		zIndex: 100,
	},
});

export const DevToolsDialogAndToggle = (): React.JSX.Element => {
	const [isOpen, setIsOpen] = useState(false);

	return (
		<>
			<Box xcss={styles.buttonWrapper}>
				<Button
					onClick={() => setIsOpen(!isOpen)}
					appearance="warning"
					iconBefore={(iconProps) => <FlaskIcon {...iconProps} label="Dev Tools" />}
				>
					Dev Tools
				</Button>
			</Box>
			<ModalTransition>
				{isOpen && (
					<Modal onClose={() => setIsOpen(false)} width="720px">
						<ModalHeader hasCloseButton>
							<ModalTitle>
								<Inline alignInline="center" space="space.100">
									<FlaskIcon label="Dev Tools" color={token('color.icon.warning')} /> Studio Dev
									Tools
								</Inline>
							</ModalTitle>
						</ModalHeader>
						<ModalBody>
							<StatsigLocalOverridesTab />
						</ModalBody>
					</Modal>
				)}
			</ModalTransition>
		</>
	);
};
